// extracted by mini-css-extract-plugin
export var banner = "_io-0";
export var closeButton = "_io-2";
export var greenCheckmark = "_io-3";
export var hereLink = "_io-4";
export var titleIcon = "_io-1";